module.exports = __webpack_public_path__ + "fonts/Manrope-500-greek9.4f6140c.woff2";